import { CinematicModal } from "@/components/ui/CinematicModal";
import { cinematicModalTitleClass } from "@/lib/cinematicModalStyles";
import { Check, Mic2, Repeat2 } from "lucide-react";

const practiceSteps = [
  {
    icon: Mic2,
    title: "Speak",
    text: "Answer out loud with the words you already know.",
  },
  {
    icon: Check,
    title: "Correct",
    text: "Get one useful repair while the sentence is still fresh.",
  },
  {
    icon: Repeat2,
    title: "Repeat",
    text: "Say the stronger version, then keep the conversation moving.",
  },
] as const;

interface HowItWorksModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function HowItWorksModal({ isOpen, onClose }: HowItWorksModalProps) {
  return (
    <CinematicModal
      isOpen={isOpen}
      onClose={onClose}
      maxWidth="2xl"
      titleId="how-it-works-dialog-title"
      contentClassName="p-4 sm:p-5"
    >
      <h2 id="how-it-works-dialog-title" className={`${cinematicModalTitleClass} pr-10`}>
        How Chicky teaches
      </h2>
      <p className="mt-1 max-w-xl pr-8 text-sm leading-6 text-white/55">
        One focused correction. One better attempt. Then back to talking.
      </p>

      <div className="relative mt-4 aspect-video w-full overflow-hidden rounded-lg border border-white/10 bg-black">
        <video
          src="/ui/See-how-it-works.mp4"
          poster="/ui/See-how-it-works-thumbnail.jpg"
          controls
          autoPlay
          playsInline
          className="h-full w-full object-contain"
          aria-label="ChickyTutor video demo showing how the AI language tutor works"
        />
      </div>

      <ol className="mt-5 grid border-y border-white/10 sm:grid-cols-3 sm:divide-x sm:divide-white/10">
        {practiceSteps.map(({ icon: Icon, title, text }, index) => (
          <li
            key={title}
            className={`grid grid-cols-[2.25rem_1fr] gap-3 py-4 sm:block sm:px-4 ${
              index > 0 ? "border-t border-white/10 sm:border-t-0" : ""
            }`}
          >
            <Icon aria-hidden="true" className="mt-0.5 h-5 w-5 text-orange-300" />
            <div>
              <h3 className="text-sm font-bold text-white">{title}</h3>
              <p className="mt-1 text-xs leading-5 text-white/55">{text}</p>
            </div>
          </li>
        ))}
      </ol>
    </CinematicModal>
  );
}
